import { render } from "./AddCourseFeedCard.vue?vue&type=template&id=494bf098&scoped=true"
import script from "./AddCourseFeedCard.vue?vue&type=script&lang=js"
export * from "./AddCourseFeedCard.vue?vue&type=script&lang=js"

import "./AddCourseFeedCard.vue?vue&type=style&index=0&id=494bf098&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494bf098"]])

export default __exports__